function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    //"cart_transfer_metafields":["custom.unspsc_code","custom.uom"],
    "graphql_token":"5ac356c204a0771df659b9f55ba6f182",
    "custom_style":"body.punchout a.header__link.action-area__link {display: none} body.punchout button.btn.return_btn:nth-child(2) { display: none !important; }",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"cart__checkout-button button custom_btn black_btn s-20786.0\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
  };
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}